import axios from 'axios';

const SIGNAL_API_URL = process.env.REACT_APP_SIGNAL_URL || 'http://localhost:3004/signals/current';

class SignalApiService {
  /**
   * Get current trading signal data
   */
  static async getCurrentSignal() {
    try {
      const response = await axios.get(SIGNAL_API_URL);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching signal data:', error);
      return { success: false, data: null, error: error.message };
    }
  }
}

export default SignalApiService;
